import { ObservablePersistLocalStorageBase } from '@legendapp/state/persist-plugins/local-storage'

import { SecureLocalStorage } from './secure_local_storage'
import { SecureSessionStorage } from './secure_session_storage'

export class ObservablePersistSecureLocalStorage extends ObservablePersistLocalStorageBase {
  constructor() {
    super(new SecureLocalStorage())
  }
}

export class ObservablePersistSecureSessionStorage extends ObservablePersistLocalStorageBase {
  constructor() {
    super(new SecureSessionStorage())
  }
}
